/** Eval Pilot logo — gradient mark (signature use) + optional wordmark. */
export function Logo({ wordmark }: { wordmark?: boolean }) {
  return (
    <div className="flex items-center gap-2">
      <div className="h-8 w-8 rounded-xl bg-brand-gradient shrink-0" aria-hidden />
      {wordmark && (
        <span className="font-display font-semibold leading-tight">
          Eval <span className="grad-text">Pilot</span>
        </span>
      )}
    </div>
  );
}
